export default "__VITE_ASSET__Drrn3ljK__"